import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { adminAPI } from '../services/api';
import AdminDashboard from '../components/Admin/AdminDashboard';
import AdminUsers from '../components/Admin/AdminUsers';
import AdminHeadaches from '../components/Admin/AdminHeadaches';
import AdminTensions from '../components/Admin/AdminTensions';
import AdminLloros from '../components/Admin/AdminLloros';
import AdminReports from '../components/Admin/AdminReports';
import AdminPushNotifications from '../components/Admin/AdminPushNotifications';
import './AdminPanel.css';

const AdminPanel: React.FC = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Verificar acceso de admin al cargar
    const checkAdminAccess = async () => {
      try {
        await adminAPI.getDashboard();
        setIsLoading(false);
      } catch (err: any) {
        setError('No tienes permisos de administrador');
        setIsLoading(false);
      }
    };

    checkAdminAccess();
  }, []);

  const isActiveRoute = (path: string) => {
    if (path === '/admin' && location.pathname === '/admin') return true;
    if (path !== '/admin' && location.pathname.startsWith(path)) return true;
    return false;
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Verificando permisos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-card">
          <h2>Acceso Denegado</h2>
          <p>{error}</p>
          <Link to="/dashboard" className="btn-primary">
            Volver al Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>🛠️ Panel Admin</h2>
        </div>
        
        <nav className="admin-nav">
          <Link 
            to="/admin" 
            className={`admin-nav-link ${isActiveRoute('/admin') ? 'active' : ''}`}
          >
            📊 Dashboard
          </Link>
          <Link 
            to="/admin/users" 
            className={`admin-nav-link ${isActiveRoute('/admin/users') ? 'active' : ''}`}
          >
            👥 Usuarios
          </Link>
          <Link
            to="/admin/headaches"
            className={`admin-nav-link ${isActiveRoute('/admin/headaches') ? 'active' : ''}`}
          >
            🤕 Dolores
          </Link>
          <Link
            to="/admin/tensions"
            className={`admin-nav-link ${isActiveRoute('/admin/tensions') ? 'active' : ''}`}
          >
            🩺 Tensiones
          </Link>
          <Link
            to="/admin/lloros"
            className={`admin-nav-link ${isActiveRoute('/admin/lloros') ? 'active' : ''}`}
          >
            😢 Lloros
          </Link>
          <Link
            to="/admin/reports"
            className={`admin-nav-link ${isActiveRoute('/admin/reports') ? 'active' : ''}`}
          >
            📈 Reportes
          </Link>
          <Link
            to="/admin/notifications"
            className={`admin-nav-link ${isActiveRoute('/admin/notifications') ? 'active' : ''}`}
          >
            🔔 Notificaciones
          </Link>
        </nav>
      </div>

      <div className="admin-content">
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="headaches" element={<AdminHeadaches />} />
          <Route path="tensions" element={<AdminTensions />} />
          <Route path="lloros" element={<AdminLloros />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="notifications" element={<AdminPushNotifications />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPanel;